module.exports = __webpack_public_path__ + "static/media/Reconciliation.1ffdc8e1.svg";